import { MdPayments, MdPeopleAlt, MdReceiptLong } from 'react-icons/md';
import { FaHome, FaWallet } from 'react-icons/fa';
import { IoMdSettings } from 'react-icons/io';
import constant from '../../utils/constant';
import { SlLink } from 'react-icons/sl';
import React from 'react';
import { BsCalendarCheck } from 'react-icons/bs';
import { TbKeyframeAlignCenterFilled } from 'react-icons/tb';
import { TiArrowRepeatOutline } from 'react-icons/ti';

export const SidebarData = [
	{
		title: 'Home',
		module: 'TRANSACTION',
		type: 'GENERAL',
		icon: <FaHome />,
		link: constant.Routes.AppHome,
	},
	{
		title: 'Payment Link',
		module: 'PAYMENT-LINK',
		icon: <SlLink />,
		link: constant.Routes.PaymentLink,
	},
	{
		title: 'Booking Link',
		module: 'PAYMENT-LINK',
		icon: <BsCalendarCheck />,
		link: constant.Routes.Booking,
	},
	{
		title: 'Invoice / Receipt',
		module: 'INVOICE/RECEIPT',
		icon: <MdReceiptLong />,
		link: constant.Routes.Invoice,
	},
	{
		title: 'Customer',
		module: 'CUSTOMER',
		icon: <MdPeopleAlt />,
		link: constant.Routes.Customer,
	},
	{
		title: 'Wallet',
		module: 'WALLET',
		type: 'GENERAL',
		icon: <FaWallet />,
		link: constant.Routes.Wallet,
	},
	{
		title: 'Transactions',
		module: 'TRANSACTION',
		type: 'GENERAL',
		icon: <MdPayments />,
		link: constant.Routes.Transactions,
	},
	{
		title: 'Client Plans & Billing',
		module: 'TRANSACTION',
		type: 'GENERAL',
		icon: <TiArrowRepeatOutline />,
		link: constant.Routes.Billing,
	},
	{
		title: 'Developer',
		icon: <TbKeyframeAlignCenterFilled />,
		link: constant.Routes.ApiKeys,
	},

	{
		title: 'Settings',
		icon: <IoMdSettings />,
		type: 'GENERAL',
		link: constant.Routes.Settings,
	},
];
